import OutlinedInput from "../Shared/OutlinedInput";
import React from "react";
import { useTheme } from "@mui/material";
import { tss } from 'tss-react';
import styles from "./styles";
import WebsaSelect from "../Shared/WebsaSelect";
import _ from "lodash";

import countryList from 'react-select-country-list';

export default function TabCompany({params, handleChange, errors}) {
  const theme = useTheme();
  const { classes } = tss.create(styles(theme))();

  const countryOptions = countryList().getData();

  return (
    <div className={classes.personal}>
      <input type="hidden" name="account[legal_type]" value="company" />
      <OutlinedInput
        customClass={classes.textField}
        name="account[name]"
        placeholder="Company name"
        value={params.name}
        onChange={handleChange("name")}
        error={errors.name}
        label="Company name"
        isUncontroled
        noAdditionalBtn
        />
      <OutlinedInput
        customClass={classes.textField}
        name="account[tax_id]"
        placeholder="Tax ID"
        value={params.tax_id}
        onChange={handleChange("tax_id")}
        error={errors.tax_id}
        label="Tax ID"
        isUncontroled
        noAdditionalBtn
        />
      <span className={classes.signature}>Optional</span>
      <WebsaSelect
        name="account[address_attributes][country_code]"
        menuHeight={196}
        options={countryOptions}
        placeholder="Country"
        label
        isSearchable
        value={_.find(countryOptions, { value: params.country_code })}
        onChange={handleChange("country_code")}
        />
      <span className={classes.signatureWebsaSelect}>Country choice will affect your products prices</span>
    </div>
  )
}
